export default "__VITE_ASSET__86a75a5c__"